import LegalPageTemplate from "@/components/LegalPageTemplate";
import LegalDocument from "@/components/LegalDocument";
import { useLocale } from "@/lib/locale";

export default function PrivacyPage() {
    const { t } = useLocale();
    return (
        <LegalPageTemplate
            docType="privacy"
            title={t("legal.privacy_title")}
            eyebrow={t("legal.privacy_eyebrow")}
            version="2026-02-v1"
        >
            <LegalDocument docKey="privacy" />
        </LegalPageTemplate>
    );
}
